<template>
  <div class="column column--1">
    <button class="btn btn--back js-btn-back d-lg-none" @click="goBack"><i class="bi bi-chevron-left"></i> Atrás</button>
    <ul>
      <li v-for="item in displayedItems" :key="item.codigo">
        <div class="item"><a :href="item.url_filtro" class="link">{{ item.descripcion }}</a>
          <button type="button" class="btn js-btn-next" @click="handleItemClick(item)"><i class="bi bi-chevron-right"></i></button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, computed } from 'vue'

export default {
  name: 'MenuNavegacion',
  props: {
    // Se espera que menuCategoria tenga la estructura anidada que se mostró en el ejemplo.
    menuCategoria: {
      type: Array,
      required: true
    }
  },
  emits: ['navigationStackEmpty'],
  setup (props, { emit }) {
    // Usaremos una “pila” (stack) para llevar el seguimiento de los niveles a medida que navegamos.
    // Cada vez que se haga click sobre un elemento que tenga hijos se empuja ese elemento a la pila.
    const navigationStack = ref([])

    // Partiendo de la estructura original, extraemos todas las líneas (del primer nivel)
    // y las “normalizamos” para incluir en cada nodo sus hijos en la propiedad `subItems`.
    const initialItems = computed(() => {
      const items = []
      props.menuCategoria.forEach(cat => {
        if (cat.lineas && Array.isArray(cat.lineas)) {
          cat.lineas.forEach(lineaObj => {
            // Cada elemento 'lineaObj' tiene la propiedad "linea" y la lista de "sublineas"
            const normalizedLine = {
              ...lineaObj.linea,
              url_filtro: lineaObj.url_filtro,
              // Si existen sublineas, las mapeamos al mismo formato
              subItems: (lineaObj.sublineas || []).map(subObj => {
                return {
                  ...subObj.sublinea,
                  url_filtro: subObj.url_filtro,
                  subItems: (subObj.familias || []).map(famObj => ({
                    ...famObj.familia,
                    url_filtro: famObj.url_filtro
                    // Si hubiera otro nivel, se podría anidar más
                  }))
                }
              })
            }
            items.push(normalizedLine)
          })
        }
      })
      return items
    })

    // El nivel que se muestra es el inicial si la pila está vacía; de lo contrario, son los hijos
    // del elemento que está en la parte superior de la pila.
    const displayedItems = computed(() => {
      if (navigationStack.value.length === 0) {
        return initialItems.value
      } else {
        const current = navigationStack.value[navigationStack.value.length - 1]
        return current.subItems || []
      }
    })

    // Al hacer click en un elemento:
    // - Si tiene hijos (subItems) se empuja el elemento a la pila para mostrar el siguiente nivel.
    // - Si no tiene hijos se podría disparar una acción (por ejemplo, redirigir).
    const handleItemClick = (item) => {
      if (item.subItems && item.subItems.length > 0) {
        navigationStack.value.push(item)
      } else {
        // Aquí podrías hacer una acción, por ejemplo redireccionar a una URL.
        // Por ejemplo:
        // router.push({ path: '/catalogo', query: { linea: item.codigo } })
        console.log('Elemento seleccionado (no tiene hijos):', item)
      }
    }

    // Función para volver al nivel anterior (quitamos el último elemento de la pila).
    const goBack = () => {
      if (navigationStack.value.length === 0) {
        emit('navigationStackEmpty')
      } else {
        navigationStack.value.pop()
      }
    }

    return {
      displayedItems,
      handleItemClick,
      goBack,
      navigationStack
    }
  }
}
</script>
